import axios from 'axios'

export default (url, keyword) => axios.get(
  url, {
    params: {
      q: encodeURIComponent(keyword),
    },
  },
)
